import React, { useState } from 'react'
import { Dialog, Button } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import ComputerIcon from '@material-ui/icons/Computer'
import googlePlay from '../../../../static/playstore.png'
import appStore from '../../../../static/appstore.png'

function DescargaConsultaEnApp () {
  const [show, setShow] = useState(true)
  const handleClose = () => { setShow(false) }

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth='xl'
      className='dialogo-descarga-app'
      fullWidth
    >
      <DialogView
        cancelCallback={handleClose}
        title=''
        content={<> <h4 style={{ textAlign: 'center' }}>
                            Podés descargar la app para Android desde la Play Store y para IOS desde la App Store
        </h4>
          <div className='container-btn-descarga-app'>
            <div className='btn-descarga-app' >
              <a href='https://play.google.com/store/apps/details?id=com.terminalquequen.tqqapp' target='blank' rel=''>
                <img style={{ width: '100%' }} src={googlePlay} alt='google-play' />
              </a>
            </div>

            <div className='btn-descarga-app' >
              <a href='https://apps.apple.com/app/id6451387467' target='blank' rel=''>
                <img style={{ width: '100%' }} src={appStore} alt='app-store' />
              </a>
            </div>
          </div>

          <Button
            className='btn-seguir-web'
            onClick={handleClose}
            variant='outlined'
          >
            <ComputerIcon fontSize='large' style={{ color: 'white' }} />
            <p style={{ margin: '0 0 0 3% ', fontSize: '1.3rem' }}>
                                Continuar en la versión web
            </p>
          </Button>

        </>
        }
      />
    </Dialog>
  )
}

export default DescargaConsultaEnApp
